import { arrowForwardIcon } from "assets/images";

const ArrowForwardIcon = () => {
  return <img src={arrowForwardIcon} alt="arrow-forward" />;
};

export default ArrowForwardIcon;
